import type {Theme} from '@chakra-ui/react';

type CleanThemeFn = (theme: Theme) => Theme;

/**
 * Cleans unused tokens from the default Chakra theme.
 */
export const cleanTheme: CleanThemeFn = theme => {
  const colors = [
    `whatsapp`,
    `twitter`,
    `facebook`,
    `messenger`,
    `telegram`,
    `linkedin`,
    `cyan`,
    `teal`,
    `red`,
    `pink`,
  ] as const;
  // Delete unused colors
  colors.forEach(color => {
    if (theme.colors[color]) delete theme.colors[color];
  });

  return theme;
};
